import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CONFIG, OKTA_STORAGE_TOKEN } from '../constants/constants';
import { getFromLocal } from './utils';

export const oktaAuth = new OktaAuth(OKTA_CONFIG);

export function getAccessToken() {
  const idToken = getFromLocal(OKTA_STORAGE_TOKEN);
  return idToken.accessToken.accessToken;
}